import load from './loader';

export default {
  install (Vue, options) {
    load(options.key);
    Vue.prototype.$google = new Promise(function (resolve, reject) {
		window['googleMapsInit'] = function () {
			resolve(window.google);
			delete window['googleMapsInit'];
		}
    });
  }
}